import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/NewsDetail.scss';
import { newsData } from '../../data/newsData';

const NewsDetail = () => {
  const { id } = useParams();
  const news = newsData[id-1];
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    comment: '',
    saveInfo: false
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 여기에 댓글 제출 로직 추가
    console.log('Comment submitted:', formData);
  };

  if (!news) {
    return <div className="news-detail-error">뉴스를 찾을 수 없습니다.</div>;
  }

  return (
    <div id="NewsDetail">
      <Header />
      <main>
        <div className="news-detail-container">
          <div className="news-header">
            <div className="news-meta">
              <span className="category">{news.category}</span>
              <span className="date">{news.date}</span>
              <span className="author">{news.author}</span>
            </div>
            <h1 className="news-title">{news.title}</h1>
          </div>
          
          <div className="news-image">
            <img src={news.img} alt={news.title} />
          </div>

          <div className="news-content">
            {news.content.split('\n').map((paragraph, index) => (
              paragraph.trim() && <p key={index}>{paragraph.trim()}</p>
            ))}
          </div>

       
  
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewsDetail; 